import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const mergeDefaults = (searchParams, defaults) => {
  const params = new URLSearchParams(searchParams);

  Object.entries(defaults).forEach(([key, value]) => {
    if (!params.has(key)) {
      params.set(key, value);
    }
  });

  return params;
};

// react-router's own `useSearchParams` defaults stop being applied once
// setSearchParams has been called, which loses them as soon as a navigation
// drops a param (filtering, for instance). Merging on every read keeps the
// defaults available for the whole lifetime of the page.
const useSearchParamsWithDefaults = (defaults) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchParamsWithDefaults = useMemo(
    () => mergeDefaults(searchParams, defaults),
    [searchParams, defaults]
  );

  const setSearchParamsWithDefaults = useCallback(
    (nextInit, navigateOptions) =>
      setSearchParams(
        typeof nextInit === "function"
          ? nextInit(searchParamsWithDefaults)
          : nextInit,
        navigateOptions
      ),
    [searchParamsWithDefaults, setSearchParams]
  );

  return [searchParamsWithDefaults, setSearchParamsWithDefaults];
};

export default useSearchParamsWithDefaults;
